.bottomNav {
	position: fixed !important;
	left: 12px;
	right: 12px;
	bottom: 0;
	transform: translateZ(0);
	visibility: visible;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
	padding: 10px 10px max(10px, env(safe-area-inset-bottom, 0px));
	max-width: 720px;
	margin: 0 auto;
	box-sizing: border-box;
	z-index: 60;
	background: color-mix(in srgb, var(--bg) 94%, transparent);
	border: 1px solid var(--border);
	border-radius: 999px;
	box-shadow: 0 8px 20px rgba(0,0,0,0.08);
	backdrop-filter: blur(6px);
}

.bottomNavButton {
	display:flex;
	gap:6px;
	align-items:center;
	justify-content:center;
	background: transparent;
	border: none;
	color: var(--text-h);
	padding: 8px 6px;
	min-height: 40px;
	cursor: pointer;
	border-radius: 999px;
	transition: background-color 0.2s ease, color 0.2s ease;
}

.bottomNavButton svg { opacity: 0.9 }

.bottomNavActive { background: var(--accent-bg); color: var(--accent) }

@media (max-width: 520px) {
	.bottomNav {
		padding: 4px 4px max(4px, env(safe-area-inset-bottom, 0px));
		bottom: 0;
		left: 6px;
		right: 6px;
	}
	.bottomNavButton {
		padding: 18px 4px;
		min-height: 34px;
		gap: 3px;
	}
}
